import { render } from "./ReportIssues.vue?vue&type=template&id=7ea04e34"
import script from "./ReportIssues.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportIssues.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Internal/Jira/ReportIssues.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ea04e34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ea04e34', __exports__)) {
    api.reload('7ea04e34', __exports__)
  }
  
  module.hot.accept("./ReportIssues.vue?vue&type=template&id=7ea04e34", () => {
    api.rerender('7ea04e34', render)
  })

}


export default __exports__